import DocumentStatus from '../types/DocumentStatus';

export default function statusToString(status: DocumentStatus | null) {
  switch (status) {
    case 'EFFECTIVE':
      return '계약 이행 중';
    case 'EXPIRED':
      return '계약 종료';
    case 'ABORTED':
      return '계약 중단';
    default:
      return '-';
  }
}
